import React, { useState } from 'react';
import "./Layout.scss"
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import Button from "../../Button/Button"
import imagePlaceholder from "../../../assets/image-placeholder.png"
import { useSelector } from 'react-redux';
import { getCurrencyFormat } from '../../../../../../utilities/helper';
const Layout = ({ layout, limit, navigate, showHeader }) => {
    const history = useHistory();

    const { menuData: { storage: { data: Categories } }, currency, menuData, orderCartData,
    } = useSelector((state) => state.resturantData);
    const selectedOrderType = "DELIVERY_BY_REWARDCONSUMER";
     const currencyFormat = getCurrencyFormat(currency);
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price.DeliveryPrice;
                break;
            case "table":
                priceValue = price.TablePrice;
                break;
            default:
                priceValue = price.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };
    const renderLayout = (menuItem, menuEntity) => {
        return (
            <div className="column">
                <div className="item-details">
                    <div className="item-dela-cont">
                        <img style={{ objectFit: !menuItem.ImageURL ? "fill" : "" }} alt="" src={menuItem.ImageURL ? menuItem.ImageURL : imagePlaceholder} className="item-image" onClick={() => { history.push('/item/' + menuEntity.ID + "/" + "new") }} />
                    </div>
                    <div className="item-des">
                        <div className="item-des-title">
                            <div className="name">{menuItem.Title.en}</div>
                            <div className="dotted-line"></div>

                            <div className="price">
                                {getThePrice(menuItem.PriceInfo.Price)}
                            </div></div>

                        <div className="details">{menuItem.Description.en}</div>
                    </div>
                </div>


            </div>
        )
    }


    return (
        <div className="Hospitality-navbar-Layout">
            {Categories.Categories && Categories.Categories.length > 0 && Categories.Categories.map((data, index) => {
                const dataLimit = limit < data.MenuEntities.length ? limit : data.MenuEntities.length

                return (
                    <div key={index} >
                        {showHeader && <div type="title" level={4} pattern="bold" className="title-menu" >{data?.Title.en}</div>}
                        <div className={`layout ${layout}`}>
                            {limit ? data.MenuEntities.slice(0, dataLimit).map(((menuEntity, key) => {
                                const menuItem = _.find(Categories.Items, { MenuItemID: menuEntity.ID });
                                if (menuItem) {
                                    return (
                                        <div className="column-styles" key={key}>
                                            {renderLayout(menuItem, menuEntity)}
                                        </div>
                                    )
                                }
                            })) :
                                data.MenuEntities.map(((menuEntity, key) => {
                                    const menuItem = _.find(Categories.Items, { MenuItemID: menuEntity.ID });
                                    if (menuItem) {
                                        return (
                                            <div className="column-styles" key={key}>
                                                {renderLayout(menuItem, menuEntity)}
                                            </div>
                                        )
                                    }
                                }))

                            }
                        </div>
                    </div>
                )
            })}
            {limit && <div className='button-container'><Button text={"LOAD MORE"} Secondary
                onClick={navigate} /></div>}
        </div >
    )
}
export default Layout